import { getApiBaseUrl } from '../utils/apiBase';
import { supabase } from '../config/supabase';

const API_BASE_URL = getApiBaseUrl();

async function authHeaders(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

class ApiClient {
  private async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`;
    const bearer = await authHeaders();

    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...bearer,
        ...options?.headers
      },
      ...options
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json() as Promise<T>;
  }

  async get<T>(endpoint: string): Promise<{ data: T }> {
    const response = await this.request<{ success: boolean; data: T }>(endpoint);
    return { data: response.data };
  }
}

export const apiService = new ApiClient();
